import { ShopInfo } from '@/shop/c_shop/component';
import i18nClient from '@/shop/c_shop/locales/i18n.config';
import { pageFavoriteRequest, URL } from '../utils/service';

const Toast = Mach.requireModule('Toast');

export function requestFavorites(url: string, shopId: string, callback: (response) => void) {
  const showIndicator = true;
  const params = {
    shopId
  };
  pageFavoriteRequest(url, params, showIndicator).then((response) => {
    if (response) {
      callback(response);
    }

    if (response?.code !== 0) {
      const message = response?.message || i18nClient.getText('order_systemerrortoast');
      Toast.show(message, 2);
    }
  }).catch((error) => {
    Toast.show(i18nClient.getText('order_systemerrortoast'), 2);
  }).finally(() => {
  });
}
